function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import { NOT_FOUND } from '../utils/constants';
import BaseStorage from '../base-storage';

var InMemoryStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(InMemoryStrategy, _BaseStorage);

  function InMemoryStrategy() {
    var _this;

    _this = _BaseStorage.call(this) || this;
    _this.memoryMap = {};
    return _this;
  }

  var _proto = InMemoryStrategy.prototype;

  _proto.setItem = function setItem(key, value, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof this.memoryMap[options.namespace] === 'undefined') {
      this.memoryMap[options.namespace] = {};
    }

    this.memoryMap[options.namespace][key] = value;
    return Promise.resolve();
  };

  _proto.getItem = function getItem(key, options) {
    if (options === void 0) {
      options = {};
    }

    var data = this.memoryMap[options.namespace] && this.memoryMap[options.namespace][key];
    return typeof data !== 'undefined' ? Promise.resolve(data) : Promise.reject(NOT_FOUND);
  };

  _proto.removeItem = function removeItem(key, options) {
    if (options === void 0) {
      options = {};
    }

    delete this.memoryMap[options.namespace][key];
    return Promise.resolve();
  };

  _proto.getAllItems = function getAllItems(options) {
    if (options === void 0) {
      options = {};
    }

    return Promise.resolve(this.memoryMap[options.namespace]);
  };

  return InMemoryStrategy;
}(BaseStorage);

export { InMemoryStrategy as default };